import { InjectionToken } from "@angular/core";

// Create an InjectionToken for media assets URL
export const MEDIA_ASSETS_URL = new InjectionToken<string>('mediaAssetsUrl');
